const humanizeKind = (kind: string): string =>
  kind
    .split("_")
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
    .join(" ");

export default humanizeKind;
